import { useContactFriendStrings } from '../../hooks';
import { CoreContext, WindowContext } from '../../providers';
import React, { useContext } from 'react';
import { BubbleSVG } from '../BubbleSVG';
import { VisibleOnVersion } from '../VisibleOnVersion';

import { ContactForm } from './ContactForm';
import {
    ClosePopupButton,
    PopupFooter,
    PopupFooterArrow,
    PopupHeading,
    PopupWrapper,
} from './styles';

export type PopupContactFormFormType = 'tellFriend' | 'challengeFriend';

interface PopupContactFormProps {
    formType: PopupContactFormFormType;
}

export const PopupContactForm = ({ formType }: PopupContactFormProps) => {
    const { currentMediaName } = useContext(WindowContext);
    const { closePopup } = useContext(CoreContext);
    const {
        data: { title, description },
    } = useContactFriendStrings(formType);

    return (
        <div>
            {currentMediaName !== 'desktop' && (
                <ClosePopupButton
                    type="button"
                    className="FactorOfferPopup__close"
                    onClick={() => closePopup()}
                >
                    X
                </ClosePopupButton>
            )}
            <PopupWrapper>
                {title && <PopupHeading>{title}</PopupHeading>}

                <VisibleOnVersion versions={['upscore', 'formue']}>
                    <BubbleSVG
                        backgroundSvgName="bubbleTop"
                        centerContentHorizontally
                        centerContentVertically
                    >
                        <ContactForm formType={formType} />
                    </BubbleSVG>
                </VisibleOnVersion>

                <VisibleOnVersion versions={['pengestyrke']}>
                    <ContactForm formType={formType} />
                </VisibleOnVersion>

                {description && (
                    <PopupFooter>
                        {description}
                        <PopupFooterArrow name="upscoreArrow" />
                    </PopupFooter>
                )}
            </PopupWrapper>
        </div>
    );
};
